// extracted by mini-css-extract-plugin
export default {"root":"AY9k6","icon":"_1BJ7u","title":"_3wxnR","subtitle":"_8JWeJ","button":"_12jgC"};